module.exports = __webpack_public_path__ + "bdb907ade7be41bdbe1944d008dc80b6.jpg";